import classNames from "classnames"

import EcoSystemIntroCardContent from "./EcoSystemIntroCardContent"

import Link from "@components/elements/Link"
import LayoutItem from "@components/V2/Layouts/LayoutItem"
import { Color } from "@constants/V2/color"
import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"
import React from "react"

type BaseProps = {
  backgroundColor: Color
  iconUrl?: string
  iconAlt?: string
  titleText: string
  descriptionText: string
  size: "large" | "medium" | "small"
  mobileGridOrder?: number
}

type Props = BaseProps &
  Partial<{
    buttonText: string
    buttonLink: string | YocoCom.YocoLink
  }>

const EcoSystemIntroCard = ({
  backgroundColor,
  descriptionText,
  titleText,
  iconUrl,
  iconAlt,
  size,
  buttonText,
  buttonLink,
  mobileGridOrder,
  ...props
}: Props) => {
  const textColor = getAccentColor(backgroundColor)
  const isClickable = !!buttonLink

  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as="div"
      animateOnScroll
      className={classNames(
        getBackgroundColorClass(backgroundColor),
        "relative col-span-full flex flex-col rounded-[25px] p-20 md:col-span-2 lg:col-span-4 lg:p-24",
        "mx-auto max-w-[335px] md:max-w-[295px] lg:max-w-[392px] xl:min-w-full",
        size === "large"
          ? "min-h-[255px] md:min-h-[288px] lg:min-h-[374px]"
          : "min-h-[130px] md:min-h-[195px] lg:min-h-[167px]",
        isClickable &&
          "cursor-pointer transition-all duration-300 hover:shadow-xl"
      )}
      {...props}
    >
      {buttonLink ? (
        <Link
          link={buttonLink}
          className="absolute inset-0"
          aria-label={titleText}
        >
          <span />
        </Link>
      ) : null}
      <div
        className={classNames(
          "pointer-events-none relative flex flex-1 flex-col",
          size === "medium" && "justify-center"
        )}
      >
        <EcoSystemIntroCardContent
          size={size}
          iconUrl={iconUrl}
          iconAlt={iconAlt}
          titleText={titleText}
          descriptionText={descriptionText}
          textColor={textColor}
          buttonText={buttonText}
          isClickable={isClickable}
        />
      </div>
    </LayoutItem>
  )
}

export default EcoSystemIntroCard
